import React from 'react';
import styled from 'styled-components';

import { InputText, Spinner, Text } from '@companycam/slab-web';
import { translate } from 'translations/i18n';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--cc_size_spacing_s);
  flex-wrap: wrap;
`;

export const StyledInput = styled(InputText)`
  flex: 1;
  margin-right: var(--cc_size_spacing_s);
  flex-basis: 100px;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const Loading = () => (
  <LoadingContainer>
    <Spinner accessibilityLabel={translate('common.loading')} />
  </LoadingContainer>
);

const HeaderContainer = styled.div`
  padding-left: var(--cc_size_spacing_xl);
  padding-top: var(--cc_size_spacing_xl);
  padding-right: var(--cc_size_spacing_xl);
`;

type ModalHeaderProps = {
  headerTitle: string;
  headerSubtitle?: string | React.ReactNode;
};

export const ModalHeader = ({
  headerTitle,
  headerSubtitle,
}: ModalHeaderProps) => {
  return (
    <HeaderContainer>
      <Text as="h1" size="l" family="heading" weight="700">
        {headerTitle}
      </Text>
      <Text
        as="h2"
        size="m"
        family="heading"
        weight="500"
        ccMargin="xs none none"
      >
        {headerSubtitle}
      </Text>
    </HeaderContainer>
  );
};

const ErrorIcon = styled.i`
  color: var(--cc_color_utility_destroy);
  margin-right: var(--cc_size_spacing_xs);
  font-size: 18px;
`;

const ErrorRow = styled.div`
  display: flex;
  align-items: center;
  color: var(--cc_color_utility_destroy);
  margin-top: var(--cc_size_spacing_xs);
`;

export const ErrorMessageRow = ({
  errorMessage,
}: {
  errorMessage?: string;
}) => {
  if (!errorMessage) return null;

  return (
    <ErrorRow>
      <ErrorIcon className="mdi mdi-alert-circle-outline" aria-hidden="true" />
      <Text as="p" size="xs" color="inherit" ccMargin="none">
        {errorMessage}
      </Text>
    </ErrorRow>
  );
};
